import styled from 'styled-components';
import { I_SIDEBAR_LOGO } from '../../types/images';

const LogoButtonWrap = styled.button<{ $mr?: number }>`
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    height: 46px;
    margin-right: ${({ $mr }) => ($mr ? `${$mr}px` : '0')};
    padding: 6px 14px 6px 8px;
    border: 1.5px solid #e2e8f0;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.82);
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.04);
    cursor: pointer;
    transition:
        transform 0.18s ease,
        box-shadow 0.18s ease,
        border-color 0.18s ease,
        background 0.18s ease;

    &:hover {
        transform: translateY(-1px);
        border-color: #cbd5e1;
        background: #ffffff;
        box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
    }

    &:active {
        transform: translateY(0);
        background: #f8fafc;
        box-shadow: 0 4px 10px rgba(15, 23, 42, 0.05);
    }
`;

const LogoMark = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 32px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(191, 219, 254, 0.92);
    background:
        radial-gradient(circle at 20% 20%, rgba(96, 165, 250, 0.18) 0%, transparent 40%),
        radial-gradient(circle at 80% 80%, rgba(37, 99, 235, 0.12) 0%, transparent 40%),
        linear-gradient(180deg, #ffffff 0%, #eef5ff 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);

    img {
        width: 27px;
        height: auto;
        filter: drop-shadow(0 1px 3px rgba(37, 99, 235, 0.12));
        transition: transform 0.18s ease;
    }

    ${LogoButtonWrap}:hover & img {
        transform: scale(1.04);
    }
`;

const BrandCopy = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
`;

const BrandName = styled.span`
    font-size: 19px;
    font-weight: 800;
    letter-spacing: -0.6px;
    line-height: 1;
    color: #2563eb;
`;

type Props = {
    callBack: () => void;
    mr?: number;
};

const LogoButton = ({ callBack, mr }: Props) => {
    return (
        <LogoButtonWrap type="button" onClick={callBack} $mr={mr} aria-label="라포 홈으로 이동">
            <LogoMark>
                <img src={I_SIDEBAR_LOGO} alt="" />
            </LogoMark>
            <BrandCopy>
                <BrandName>Rappo</BrandName>
            </BrandCopy>
        </LogoButtonWrap>
    );
};

export default LogoButton;
